module.exports = {

    1:  'task.create',
    2:  'task.delete',
    3:  'task.move',
    4:  'task.assignedTo',
    5:  'task.actionRequired',
    6:  'task.priority',
    7:  'task.deadline',
    8:  'task.estimate',
    9:  'task.startEnd',
    10: 'task.schedule',
    11: 'task.description',
    12: 'task.view',
    13: 'task.status',
    14: 'task.close',
    15: 'task.reopen',

    30: 'task.message.create',
    31: 'task.message.delete',
    32: 'task.message.edit',

    100: 'project.create',
    101: 'project.delete',
    102: 'project.status',

    300: 'timelog.create',
    301: 'timelog.delete',
    302: 'timelog.status',


    exportToOptions() {
        const eventsOrder = [
            1,13,14,15,2, //3,4,5,6,7,8,9,10,11,12,
            //30, //32,31,

            100, 101, 102,

            300, 301, 302
        ];
        const options = [];
        eventsOrder.map(event=>{
            options.push({
                value: event,
                label: gd.const.systemEvent[event]
            })
        });

        return options;
    }

};